import { getCheckListCount, Inspection } from "./Inspection";

export interface SideBarData {
    shipName: string;
    shipIMO: string;
    inspectionId: string;
    imageElements: any[];
    numberOfPhotos: number;
    numberOfDocuments: number;
    numberOfCheckLists: number;
    numberOfPhotoElements: number;
    numberOfDocumentElements: number;
    numberOfChecklistElements: number;
    numberOfDefects?: number;
}

export const initialSideBar: SideBarData = {
    shipName: "",
    shipIMO: "",
    inspectionId: "",
    imageElements: [],
    numberOfPhotos: 0,
    numberOfDocuments: 0,
    numberOfCheckLists: 0,
    numberOfPhotoElements: 0,
    numberOfDocumentElements: 0,
    numberOfChecklistElements: 0,
    numberOfDefects: 0
};

export function getSideBarForInspection(inspection: Inspection) {
    const imageElements = inspection.sections;
    const elementDetails: any[] = [];

    for (let i = 0; i !== imageElements.length; i++) {
        if (
            imageElements[i].MinItems &&
            imageElements[i].MinItems >= 1 &&
            imageElements[i].MaxItems > 1 &&
            imageElements[i].ElementType === 2
        ) {
            elementDetails.push({
                name: imageElements[i].Name,
                id: imageElements[i].Id
            });
        }
    }

    const checkListsCount = getCheckListCount(inspection);

    return {
        shipName: inspection.ShipName,
        shipIMO: inspection.ShipIMO,
        inspectionId: inspection.Id,
        imageElements: elementDetails,
        numberOfPhotos: inspection.NumberOfPhotos,
        numberOfDocuments: inspection.NumberOfDocuments,
        numberOfCheckLists: checkListsCount,
        numberOfDocumentElements: inspection.DocumentElementsCount,
        numberOfPhotoElements: inspection.ImageElementsCount,
        numberOfChecklistElements: inspection.ChecklistElementsCount
    };
}
